import { BigNumberish, BytesLike } from "ethers";

export interface QuoteTransactionsResponse {
    transactions: Quote[],
    amountReceived: BigNumberish;
    originSlippage: BigNumberish;
    routerFee: BigNumberish;
    destinationSlippage: BigNumberish;
}

export class Quote {
    to?: string;
    data?: BytesLike;
    value?: BigNumberish;
    gasLimit?: string;
    gasPrice?: string;
    chainId?: number;
}
